import React from "react";

import { IImageData } from '../../../pages/Root/services/api/interfaces.ts';
import PublisherLogo from '../PublisherLogo/PublisherLogo.tsx';
import { StorySize } from '../../types/story-types'
import Image from '../../../components/Image/Image.tsx';

import "./StoryCarousel.scss";

interface StoryCarouselProps {
  imageList: IImageData[];
  title: string;
  description: string;
  publisherLogo?: string;
  darkPublisherLogo?: string;
  publisherName?: string;
}

const StoryCarousel: React.FC<StoryCarouselProps> = ({ imageList, title, description, publisherLogo, darkPublisherLogo, publisherName }) => {
  return (
    <div className="story-carousel">
      <div className="story-content">
        <Image
          withSkeleton
          alt={title}
          imageList={imageList}
          className="story-image-cr"
          imageContainerClassName="border-radius-sm"
        ></Image>

        <div className="story-text">
          {publisherLogo && <PublisherLogo publisherLogo={publisherLogo} darkPublisherLogo={darkPublisherLogo} publisherName={publisherName ?? ''} storySize={StorySize.CAROUSEL}/>}
          <h2 className="story-title">{title}</h2>
          <p className="story-description">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default StoryCarousel;
